import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes
})
router.onError((error) => {
  const pattern = /Loading chunk/ig
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed && targetPath) {
    if (typeof window!='undefined' && window.location) {
      window.location.replace(targetPath)
    }
  }
})
export default router
